module.exports = __webpack_public_path__ + "static/media/thumbnail_doc5.7e4df503.png";